var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BasePageWrapper',{attrs:{"title":"What type of photo you preferred ?","title-align":"center","content-space":"30px 0 0 0"}},[_c('CardTypeList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }